import classNames from 'classnames';
import { useEffect, useState } from 'react';

import { implog } from '@/api/implog';
import dp01 from '@/assets/pwa/dp01.webp';
import dp02 from '@/assets/pwa/dp02.webp';
import dp03 from '@/assets/pwa/dp03.webp';
import dp04 from '@/assets/pwa/dp04.webp';
import dpai from '@/assets/pwa/dpai.webp';
import BlurryLoadingImage from '@/components/progressive-img';
import { safePreModalClick } from '@/Layout/download/event';

import styles from './styles.module.less';

const AndroidPwaSofe = () => {
  const list = [
    {
      title: 'Virus Search',
      content: 'Scanning....',
      time: 3.3,
      content1: 'No viruses found'
    },
    {
      title: 'Fake App Verification',
      content: 'Scanning....',
      content1: 'The app is legitimate',
      time: 6.6
    },
    {
      title: 'Other Risks',
      content: 'Scanning....',
      time: 10,
      content1: 'No other risks found'
    }
  ];
  const [time, setTime] = useState(0);

  useEffect(() => {
    let newTime = 0;
    setTime(newTime);
    const clearTimer = setInterval(() => {
      if (newTime >= 100) {
        clearInterval(clearTimer);
        return;
      }
      newTime += 1;
      setTime(newTime);
    }, 100);
    return () => {
      if (clearTimer) {
        clearInterval(clearTimer);
      }
    };
  }, []);

  // const getTitle = () => {
  //   if (__PRODUCT_NAME__ === 'goldSlot') return window?.privateConfig?.title;
  //   if (window?.privateConfig?.hz) return 'Tiger Slot';
  //   return '7USslot';
  // };

  useEffect(() => {
    implog('android_pwa_safe_modal_show');
  }, []);

  const isFinish = time >= 100;

  return (
    <div className={styles.main}>
      <div className={styles.bg}>
        <BlurryLoadingImage loading="lazy" src={isFinish ? dp01 : dp02} alt="" />
      </div>
      <div className={styles.content}>
        <div className={styles.head}>
          <div className={styles.title}>
            {isFinish ? (
              <>
                <div>Security Tests</div>
                <div>passed</div>
              </>
            ) : (
              <div>Security Scan</div>
            )}
          </div>
          <div className={styles.subtitle}>{isFinish ? 'No risks detected' : 'Scanning....'}</div>
        </div>

        <div className={styles.logo_box}>
          <div className={styles.logo}>
            <BlurryLoadingImage loading="lazy" src={window.privateConfig?.pwaLogo || '/googlePlay/Bet787/logo.webp'} />
          </div>
          <div className={styles.logo_right}>
            <div className={styles.logo_right_title}>{window?.privateConfig?.title || '7USslot'}</div>
            <div className={styles.logo_right_percentage}>{time}%</div>
            <div className={styles.logo_right_bottom}>
              <BlurryLoadingImage loading="lazy" src={dpai} />
              <span>Verified by Play Protect</span>
            </div>
          </div>
        </div>
        {list.map(item => {
          const isFinish = time / 10 >= item.time;

          return (
            <div
              className={classNames(styles.item, {
                [styles.finish]: isFinish
              })}
              key={item.title}
            >
              <div className={styles.item_left}>
                <div className={styles.item_left_title}>{item.title}</div>
                <div className={styles.item_left_subtext}>{isFinish ? item.content1 : item.content}</div>
              </div>
              <div className={styles.item_right}>
                <BlurryLoadingImage loading="lazy" src={isFinish ? dp03 : dp04} />
              </div>
            </div>
          );
        })}
        <div className={styles.button}>
          <button
            onClick={() => {
              safePreModalClick();
            }}
          >
            Open
          </button>
        </div>
      </div>
    </div>
  );
};

export default AndroidPwaSofe;
